const greyAscent = [
  '#ffffff',
  '#e6e6e6',
  '#cccccc',
  '#b3b3b3',
  '#999999',
  '#808080',
  '#666666',
  '#4d4d4d',
  '#333333',
  '#1a1a1a',
  '#000000',
];

const greyRGBA = [
  'rgba(67, 89, 113, 0.5)',
  'rgba(67, 89, 113, 0.6)',
  'rgba(67, 89, 113, 0.8)',
  'rgba(67, 89, 113, 0.025)',
  'rgba(67, 89, 113, 0.05)',
];

const greyPrimary = ['#0d0d0d', '#2a2a2a', '#f9fafc'];

const grey = [...greyAscent, ...greyRGBA, ...greyPrimary];

const MuiMindCode = {
  custom: {
    white: '#ffffff',
    content: '#f9fafc',
    textBorder: '#C4C4C4',
    tableHead: '#F8F8F8',
    proceeding: '#FB8832',
    completed: '#4AAF05',
    pending: '#FF5756',
    backgroundDefault: '#f9fafb',
    description: '#8F9BB3',
    adminButton: '#0095FF',
    guestButton: '#EFF4FA',
    checkBorder: '#616161',
  },
  grey: {
    A0: grey[0],
    A50: grey[1],
    A100: grey[2],
    A200: grey[3],
    A300: grey[4],
    A400: grey[5],
    A500: grey[6],
    A600: grey[7],
    A700: grey[8],
    A800: grey[9],
    A900: grey[10],
    R5: grey[11],
    R6: grey[12],
    R8: grey[13],
    R025: grey[14],
    R050: grey[15],
    primary: grey[16],
    secondary: grey[17],
    light: grey[18],
    disabled: '#AAAAAA',
    brown: '#434343',
    progress: '#ebebeb',
    border: '#EEF0F6',
    border2: '#cccccc',
    checkBorder: '#a6a6a6',
    placeholder: '#cbcbcb',
    alert: '#676767',
    greyHover: '#F6F6F6',
  },
  black: {
    A0: '#000000',
    A10: '#0d0d0d',
    A20: '#111111',
    A70: 'rgba(0, 0, 0, 0.7)',
  },
  blue: {
    azul: '#3154ea',
  },
  menu: {
    collapse: '#050505',
    notSelected: '#0d0d0d',
    selected: '#3154ea',
    icon: '#0d0d0d',
    border: '#E9E9E9',
    pageTitle: '#2a2a2a',
  },
  page: {
    button1: '#f6f6f6',
    button1hover: '#788393',
  },
  grid: {
    boxZero: '#FF0000',
    pointBox: '#BDBBBB',
  },
  divider: 'rgba(112, 112, 112, 0.15)',
};

type CustomMindCode = {
  [Key in keyof typeof MuiMindCode]: (typeof MuiMindCode)[Key];
};

declare module '@mui/material/styles' {
  interface Palette {
    mind: CustomMindCode;
  }

  interface PaletteOptions {
    mind?: CustomMindCode;
  }
}
declare module '@mui/material/Button/Button' {
  interface ButtonPropsColorOverrides {
    [key: string]: true;
  }
}

export default MuiMindCode;
